<template>
    <div>
        <a-upload
                name="file"
                :multiple="true"
                action="http://media.cn3x.com.cn/api/AliyunOss/Imgesupload"
                :customRequest="customRequest"
                :headers="headers"
                @change="handleChange">
            <a-button>
                <a-icon type="upload" /> Click to Upload
            </a-button>
        </a-upload>
        <a-progress :percent="percentage" />
    </div>
</template>
<script>
    import axios from 'axios'

    export default {
        data () {
            return {
                headers: {
                    Authorization: window.localStorage.getItem('token'),
                },
                percentage:0
            }
        },
        methods: {
            async customRequest (filetxt) {
                var pic
                var xhr = new XMLHttpRequest();
                const LENGTH = 1024 * 1024*2;
                var start = 0;
                var end ;
                var blob = filetxt.file ;
                var blob_num = 1;
                var total_blob_num ;
                total_blob_num = Math.ceil(blob.size / LENGTH);
                // while (start < blob.size)
                // {
                    end = start + LENGTH;
                    if (end > blob.size) { end = blob.size; }
                    var file_blob = blob.slice(start,end);
                    var name_blob = blob.name + blob_num;

                    var form_data = new FormData();
                    form_data.append('file',file_blob,name_blob);
                    form_data.append('blob_num',blob_num);
                    form_data.append('total_blob_num',total_blob_num);
                    form_data.append('file_name',blob.name);
                    form_data.append('token',window.localStorage.getItem('token'));
                    axios.post(filetxt.action,form_data)
                        .then(res=>{
                            console.log(res)
                        })
                    //
                    // xhr.open('POST',filetxt.action,false);
                    // this.percentage = Math.round(end / blob.size * 100);
                    // xhr.onreadystatechange = function () {
                    //     //判断对象状态是否交互完成，如果为4则交互完成    判断对象状态是否交互成功,如果成功则为200
                    //     if(xhr.readyState ==4 && xhr.status === 200) {
                    //         let resultJson =  eval('(' + xhr.response + ')');
                    //         pic = resultJson
                    //         pic['name'] = pic.url
                    //     }
                    // }
                    // xhr.send(form_data);
                    // start = end;
                    // blob_num++ ;
                // }
                console.log(pic);
            },
            handleChange(info) {
                if (info.file.status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                    this.$message.success(`${info.file.name} file uploaded successfully`);
                } else if (info.file.status === 'error') {
                    this.$message.error(`${info.file.name} file upload failed.`);
                }
            },
        },
    }
</script>
